<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  methods: {},
  mounted () {

  }
}
</script>

<style>
#app {
  height: 100%;
  font-family: PingFangSC-Semibold, PingFang SC, pingFangSC-Regular;
  font-weight: 400;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
</style>
